import React from 'react';
import { useStore, useActions } from '../../hooks/useStore';
import SessionModal from './SessionModal';

interface SessionModalContainerProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Container for SessionModal (ADR-034).
 * Owns store access for gameTime, sessionNotes, and mutation callbacks.
 */
const SessionModalContainer: React.FC<SessionModalContainerProps> = ({ isOpen, onClose }) => {
  const generalState = useStore(state => state.session?.general);
  const gameTime = generalState?.gameTime ?? new Date();
  const sessionNotes = generalState?.sessionNotes ?? '';
  const actions = useActions();

  const handleUpdateSessionNotes = (notes: string) => {
    actions.updateSessionNotes(notes);
  };

  const handleSetGameTime = (newTime: string) => {
    actions.setGameTime(newTime);
  };

  return (
    <SessionModal
      isOpen={isOpen}
      onClose={onClose}
      gameTime={gameTime.toISOString()}
      sessionNotes={sessionNotes}
      onUpdateSessionNotes={handleUpdateSessionNotes}
      onSetGameTime={handleSetGameTime}
    />
  );
};

export default SessionModalContainer;
